import { render, staticRenderFns } from "./HttpRecordDetail.vue?vue&type=template&id=b08b2320&scoped=true"
import script from "./HttpRecordDetail.vue?vue&type=script&lang=js"
export * from "./HttpRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./HttpRecordDetail.vue?vue&type=style&index=0&id=b08b2320&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08b2320",
  null
  
)

export default component.exports